import React from 'react';
import { Button } from '@/components/ui/button';
import { User, Building2, Landmark } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

interface QualificationStepProps {
  onComplete: (data: { userType: 'particulier' | 'professionnel' | 'collectivite' }) => void;
}

export const QualificationStep = ({ onComplete }: QualificationStepProps) => {
  const isMobile = useIsMobile();

  return (
    <div className="space-y-4">
      <div className="grid gap-2.5 grid-cols-1">
        <Button
          onClick={() => onComplete({ userType: 'particulier' })}
          variant="outline"
          className="flex items-center justify-center gap-2.5 rounded-xl h-14 text-[15px] text-[#0a2540] hover:text-[#0a2540] border-[#0a2540]/15 hover:border-[#C9A96E] hover:bg-[#0a2540]/[0.03] transition-colors"
        >
          <User className={`${isMobile ? 'w-5 h-5' : 'w-4 h-4'}`} />
          Particulier
        </Button>
        <Button
          onClick={() => onComplete({ userType: 'professionnel' })}
          variant="outline"
          className="flex items-center justify-center gap-2.5 rounded-xl h-14 text-[15px] text-[#0a2540] hover:text-[#0a2540] border-[#0a2540]/15 hover:border-[#C9A96E] hover:bg-[#0a2540]/[0.03] transition-colors"
        >
          <Building2 className={`${isMobile ? 'w-5 h-5' : 'w-4 h-4'}`} />
          Entreprise
        </Button>
        <Button
          onClick={() => onComplete({ userType: 'collectivite' })}
          variant="outline"
          className="flex items-center justify-center gap-2.5 rounded-xl h-14 text-[15px] text-[#0a2540] hover:text-[#0a2540] border-[#0a2540]/15 hover:border-[#C9A96E] hover:bg-[#0a2540]/[0.03] transition-colors"
        >
          <Landmark className={`${isMobile ? 'w-5 h-5' : 'w-4 h-4'}`} />
          Collectivité
        </Button>
      </div>
    </div>
  );
};
